<div
  class="barcode-component w-100 d-flex flex-column d-lg-none"
  *ngIf="barcode$ | async as barcode"
  [ngClass]="{ 'show-footer': showFooter, season: season, premium: premium, sgb: sgb }"
>
  <ng-container *ngIf="!isWalletPage">
    <div class="member-details" [ngClass]="season ? 'text-white' : 'tetx-secondary'">
      <div class="fw-bold card-name" *ngIf="memberDetails$ | async as memberDetails">
        {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
      </div>
      <ng-container *ngIf="card$ | async as memberCard">
        <div class="font-size-12">
          <div>{{ memberCard.ProductCode }} {{ 'product.code.description' | translate }}</div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <!--Barcode-->
  <ng-container *ngIf="showBarcode">
    <div class="qr-container d-flex flex-column">
      <div class="qr w-100 rounded-4 d-flex flex-column align-items-center justify-content-center">
        <qrcode [qrdata]="barcode.Barcode" [size]="256" [level]="'M'" [usesvg]="true"></qrcode>
        <p class="font-size-12 mb-0" [ngClass]="season ? 'text-white' : 'tetx-secondary'">
          {{ 'scan.member.barcode' | translate }}
        </p>
      </div>

      <div class="discount-details" *ngIf="card$ | async as memberCard">
        <ng-container *notInProductCode="productcode.SGB">
          <div class="discount-item">
            <span class="item-label" [ngClass]="season ? 'text-white' : 'text-secondary'">{{
              'member.card.retail.discount' | translate
            }}</span
            ><span class="item-value" [ngClass]="season ? 'text-white' : 'text-secondary'"
              >{{ memberCard.RetailDiscountLevel }}%</span
            >
          </div>
        </ng-container>
        <div class="discount-item">
          <ng-container *notInProductCode="productcode.SGB">
            <span class="item-label" [ngClass]="season ? 'text-white' : 'text-secondary'">{{
              'member.card.discount' | translate
            }}</span>

            <span class="item-value" [ngClass]="season ? 'text-white' : 'text-secondary'">{{ memberCard.DiscountLevel }}%</span>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    *ngIf="showBarcode"
    [ngClass]="season ? 'text-white' : 'text-secondary'"
    class="ecash-balance d-flex align-items-center justify-content-between"
  >
    <div class="font-size-12">
      {{ 'barcode.credit.label' | translate }}
    </div>

    <div class="credit-balance">
      <span class="material-symbols-outlined"> money_bag </span>
      <h4 class="mb-0">{{ eCash$ | async | FortressCurrencyPipe }}</h4>
    </div>
  </div>

  <fgb-ecash-button [textColor]="season ? 'text-white' : 'text-secondary'"></fgb-ecash-button>

  <ng-container *ngIf="isHomePage">
    <ng-container *notInProductCode="productcode.SGB">
      <fgb-mobile-navigation [textColor]="season ? 'text-white' : 'text-secondary'" />
    </ng-container>
  </ng-container>
</div>
